import { LinkProps } from '@mui/material/Link'
import { LinkBehavior } from 'ui'

import { text } from '../colors'

export const MuiLink = {
  defaultProps: {
    component: LinkBehavior,
  } as LinkProps,
  styleOverrides: {
    root: {
      textDecorationColor: 'unset',
      '&.MuiTypography-root.secondaryColor': {
        color: text.secondary,
      },
    },
  },
}
